import { render, staticRenderFns } from "./ImageOCRPopup.vue?vue&type=template&id=1158a637&scoped=true"
import script from "./ImageOCRPopup.vue?vue&type=script&lang=js"
export * from "./ImageOCRPopup.vue?vue&type=script&lang=js"
import style0 from "./ImageOCRPopup.vue?vue&type=style&index=0&id=1158a637&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1158a637",
  null
  
)

export default component.exports